import {createContext, MutableRefObject} from 'react'
import {Hit} from '../store/ProductStore'

export type TrackViewItem = (hit: Hit, hasBeenSentRef: MutableRefObject<boolean>, hitItemIndex?: number) => void

export const ViewItemListContext = createContext<TrackViewItem | null>(null)
